import { Box, Button, Menu, SxProps } from '@mui/material';
import Icon from '@mdi/react';
import React, { PropsWithChildren, useState } from 'react';
import { ceraProBold } from '../../../Theme';

/**
 * Component for buttons that show dropdown menus in the Header.
 */
export default (props: IHeaderMenuButtonProps) => {
    /** State slice for controlling the position of the button's menu. */
    const [anchorEl, setAnchorEl] = useState<HTMLElement>(null);

    /** Deconstruct props. */
    const { color, icon, sx, children, text, title } = props;

    /** Button styles. */
    const buttonSx: SxProps = {
        minWidth: 24,
        px: 1,
        color,
        textTransform: 'none',
        fontFamily: ceraProBold,
        fontSize: '16px',
        lineHeight: 'normal',
        fontWeight: 700,
        ...sx,
    };

    return (
        <>
            <Button title={title} sx={buttonSx} onClick={e => setAnchorEl(e.currentTarget)}>
                {icon && (typeof icon === 'string' ? <Icon path={icon} size={1} /> : icon)}
                {text && <Box sx={{ pl: +!!icon }}>{text}</Box>}
            </Button>

            <Menu
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={() => setAnchorEl(null)}
                onClick={() => setAnchorEl(null)}
            >
                {children}
            </Menu>
        </>
    );
};

/**
 * Interface that describes the props for a HeaderMenuButton component.
 */
interface IHeaderMenuButtonProps extends PropsWithChildren {
    /** (Optional) Button   */
    title?: string;

    /** (Optional) Button text.  */
    text?: string;

    /** (Optional) Button icon. */
    icon?: string | React.ReactNode;

    /** Button font color. */
    color: string;

    /** (Optional) Button styles. */
    sx?: SxProps;
}
